



















import { Component, Vue, Watch } from "vue-property-decorator";
import { Carousel, Slide } from "vue-carousel";
import { IMerchant } from "@/store/interfaces/merchant";
import MerchantCard from "./MerchantCard.vue";
import { mapGetters } from "vuex";

@Component({
  name: "TopMerchantContainer",
  components: {
    Carousel,
    Slide,
    MerchantCard
  },
  computed: {
    ...mapGetters({
      getTopMerchants: "home/getTopMerchants",
      isLoadnig: "home/isLoading",
      lang: "app/lang"
    })
  }
})
export default class TopMerchantContainer extends Vue {
  getTopMerchants: IMerchant[];
  @Watch("lang")
  async onLangChanged() {
    this.$store.dispatch("home/updateHomeFromAPI");
  }
}
